module.exports = __webpack_public_path__ + "static/hotsnail-vertical-0b79fd60f7af7de8b31f65d18a4de0bd.png";